// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
      /**
       * if you want to use image instead of svg uncomment following, and comment out <svg> element.
       *
       * <img src={theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon} alt="icon logo" width="100" />
       *
       */
      <svg xmlns="http://www.w3.org/2000/svg" width="66" height="28" viewBox="0 0 265 243" fill="none">
          <path
              d="M66.36 146.531C60.632 146.531 54.855 143.662 50.467 138.275C30.406 113.606 12.294 67.5282 11.535 65.5692L0 36.0131L25.208 55.274C44.52 70.0271 77.415 84.4303 86.72 86.8392C87.53 87.0491 88.34 86.9591 89.079 86.5993L264.149 0L259.191 18.8812C243.139 79.9924 214.462 113.856 193.241 131.508C181.607 141.183 165.874 144.861 151.151 141.363C131.72 136.745 106.811 131.928 95.616 130.618C94.267 130.468 92.947 130.688 91.738 131.278L75.455 143.922L74.916 144.232C72.207 145.781 69.288 146.541 66.36 146.541M39.602 85.2699C46.309 99.2933 55.215 115.925 64.261 127.05C65.04 128.009 65.73 128.469 66.12 128.659L81.922 116.395L82.462 116.085C87.12 113.416 92.378 112.327 97.695 112.956C109.46 114.336 135.288 119.313 155.269 124.061C164.575 126.27 174.53 123.941 181.877 117.834C198.789 103.761 220.979 78.1333 236.192 33.6542L96.966 102.521C92.418 104.77 87.2 105.32 82.282 104.041C74.656 102.072 56.814 94.6155 39.602 85.2699Z"
              fill="#1CACE4"/>
          <path
              d="M242.879 82.9008C219.15 120.403 192.802 156.046 160.237 186.072C148.162 197.337 135.718 207.222 122.674 216.837C89.2392 196.147 62.9312 170.089 38.2822 132.627C39.8822 148.4 46.2892 163.283 54.3652 176.816C67.1492 197.986 86.0912 215.658 108.051 227.373C104.362 229.971 100.634 232.59 96.8362 235.229C103.483 234.509 110.07 233.27 116.567 231.551C134.588 239.617 154.259 243.735 174.05 242.645C160.487 237.048 147.972 231.151 136.308 224.774C192.622 200.915 238.021 142.323 242.879 82.9209"
              fill="#1CACE4"/>
      </svg>
  );
}
